import {
  Button,
  Dialog,
  DialogBody,
  DialogContent,
  DialogTitle,
  IconButton,
} from "@suraasa/placebo-ui"
import SuccessFormSubmit from "components/SuccessfulSubmitDialog"
import { Xmark } from "iconoir-react"

type Props = {
  open: boolean
  onClose: () => void
  onProceed: () => void
}

const SuccessDialog = (props: Props) => {
  return (
    <Dialog open={props.open} onOpenChange={props.onClose}>
      <DialogContent className="max-w-[480px]">
        <div className="absolute right-4 top-4 z-10">
          <IconButton onClick={props.onClose} color="black" variant="plain">
            <Xmark />
          </IconButton>
        </div>

        <DialogBody className="mt-4 flex flex-col items-center p-2 text-center sm:p-3">
          <SuccessFormSubmit
            title="Onboarding Completed!"
            description="Your profile is now ready. You can proceed to start your assessment and showcase your pedagogy skills."
          />
          <Button
            color="black"
            size="lg"
            onClick={props.onProceed}
            className="mt-8 w-full"
          >
            Proceed to assessment
          </Button>
        </DialogBody>
      </DialogContent>
    </Dialog>
  )
}

export default SuccessDialog
